import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

const StickyBackground = () => {
  const firstBlock = document.querySelector('.richNightCare');
  const secondBlock = document.querySelector('.mainIng');
  const firstBackground = document.querySelector('.sokyu__bgImg--first');
  const secondBackground = document.querySelector('.sokyu__bgImg--second');
  gsap.registerPlugin(ScrollTrigger);

  ScrollTrigger.create({
    trigger: firstBlock,
    start: 'top top',
    end: 'bottom top',
    onEnter: () => {
      firstBackground.classList.add('isShow');
    },
    onEnterBack: () => {
      firstBackground.classList.add('isShow');
    },
    onLeave: () => {
      firstBackground.classList.remove('isShow');
    },
    onLeaveBack: () => {
      firstBackground.classList.remove('isShow');
    },
  });

  ScrollTrigger.create({
    trigger: secondBlock,
    start: 'top-=25% top',
    end: 'bottom-=30% top',
    onEnter: () => {
      secondBackground.classList.add('isShow');
    },
    onEnterBack: () => {
      secondBackground.classList.add('isShow');
    },
    onLeave: () => {
      secondBackground.classList.remove('isShow');
    },
    onLeaveBack: () => {
      secondBackground.classList.remove('isShow');
    },
  });
};

export default StickyBackground;
